import * as DateF from 'date-fns'
import styled from 'styled-components'

import { Typography } from '@blade/ui-kit'
import { DATE_FORMAT } from '@root/shared'
import { useTranslation } from '@root/shared/localization'

import {
  TRX_STATUS_COLOR_MAP,
  TRX_STATUS_ICON_MAP,
  TRX_STATUS_LABEL_MAP,
} from '../constants'

import type { TransactionListItemVariant } from './transaction-list-item'
import type { Transaction } from '../../model'

type Props = {
  tx: Transaction.Transaction
  variant: TransactionListItemVariant
}

export const TransactionListItemStatus: React.FC<Props> = ({ tx, variant }) => {
  const { t } = useTranslation()

  const StatusIcon = TRX_STATUS_ICON_MAP[tx.status]

  return (
    <Root data-variant={variant}>
      <Date>{DateF.format(tx.createdAt, DATE_FORMAT.HH_mm__dd_MM_yy)}</Date>
      <State data-status={tx.status}>
        <Icon>
          <StatusIcon size={9} />
        </Icon>
        <Label>{t(TRX_STATUS_LABEL_MAP[tx.status]).toLowerCase()}</Label>
      </State>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  justify-content: space-between;
  grid-template-columns: auto auto;

  &[data-variant='square'] {
    border-top: 1px solid var(--background-3);
    padding-top: 4px;
  }
`

const State = styled.div`
  &[data-status='failed'] {
    color: ${TRX_STATUS_COLOR_MAP.failed};
  }
  &[data-status='success'] {
    color: ${TRX_STATUS_COLOR_MAP.success};
  }
  &[data-status='pending'] {
    color: ${TRX_STATUS_COLOR_MAP.pending};
  }

  display: grid;
  gap: 2px;
  grid-template-columns: auto auto;
  align-items: center;
  justify-items: end;

  width: auto;
`

const Icon = styled.div`
  height: 10px;
  display: grid;
  align-content: end;
`

const Label = styled(Typography).attrs({
  variant: 'description-medium',
  component: 'span',
})`
  display: flex;
  align-items: end;
  white-space: nowrap;
`

const Date = styled(Typography).attrs({
  variant: 'description-semi-bold',
  component: 'span',
})`
  color: var(--text-10);
  text-align: right;
`
